export default __webpack_public_path__ + "static/media/hvac-icon.f0ecfc11.svg";